import { Scene } from 'phaser';
import EDC from '@/components/games/shared/globals';
import Preloader from './preloader';
import Main from './main';

class SiteMenuScene extends Scene {
  create() {
    this.addStates();
    this.scene.start('preloader');
  }

  addStates() {
    this.scene.add('preloader', Preloader);
    this.scene.add('main', Main);
  }
}

EDC.Scenes.Boot = SiteMenuScene;

export default SiteMenuScene;
